import { Toast } from 'mint-ui';

export default {
  data() {
    const { query = {} } = this.$route;
    return {
      verifyMsg: '',
      countdown: 5,
      counttimer: null,
      showVerifyForm: false,
      showVerifySucc: false,

      token: query.token || '',
      clientType: query.clientType || 1,
      type: '1',
      name: '',
      mobile: '',
      idLast4: '',
      disabled: false,
    };
  },
  computed: {
    isH5() {
      return this.clientType == 1;
    },
    isRegisted() {
      return this.type === '1';
    },
  },
  mounted() {
    this.validLink();
  },
  watch: {
    verifyMsg(msg) {
      if (msg) {
        this.showVerifyForm = false;
        this.startCount();
      }
    },
  },
  methods: {
    /**
     * 验证链接有效性
     */
    async validLink() {
      try {
        const { ret, msg } = await this.$http.get('/user/verify/link/valid', {
          token: this.token,
        });
        this.showVerifyForm = ret === 0;
        if (ret !== 0) throw new Error(msg);
      } catch (error) {
        this.verifyMsg = error.message || '服务异常，请稍后再试';
      }
    },
    startCount() {
      this.countdown = 5;
      this.counttimer = setInterval(() => {
        if (!this.countdown) {
          clearInterval(this.counttimer);
          this.counttimer = null;
          this.closeWindow();
        } else {
          this.countdown--;
        }
      }, 1000);
    },
    /**
     * 提交表单
     */
    async submit() {
      const { token, type, name, mobile, idLast4, disabled, isRegisted } = this;

      if (disabled) return;

      const params = {
        token,
        type: Number(type),
      };

      // 注册用户输入校验
      if (isRegisted) {
        if (!name) {
          Toast('请输入您的姓名');
          return;
        }

        if (!/^1[3|4|5|6|7|8|9]\d{9}$/.test(mobile)) {
          Toast('请输入正确的手机号');
          return;
        }

        if (!/\d{3}[0-9Xx]$/.test(idLast4)) {
          Toast('请输入正确的身份证号后四位');
          return;
        }

        params.name = name;
        params.mobile = mobile;
        params.idLast4 = idLast4;
      }

      try {
        this.disabled = true;
        const { ret, msg, data = {} } = await this.$http.postJson('/user/verify', params);
        /**
         * ret = 0 && pass = 1: 验证通过
         * ret = 0 && pass = 0 && failTimes < 3: 验证失败，请核实后再提交
         * ret = 0 && pass = 0 && failTimes >= 3: 验证失败，失败次数超限，为您返回人工客服
         * ret = 1: 接口异常
         */
        if (ret === 0) {
          if (data.pass === 1) {
            this.verifyMsg = '验证成功';
            this.showVerifySucc = true;
            return;
          }

          if (data.failTimes >= 3) {
            this.verifyMsg = '验证失败，失败次数超限，为您返回人工客服';
            return;
          }
        }

        // 非验证通过 or 次数超限，需先校验链接有效性
        await this.validLink();
        if (this.showVerifyForm) throw new Error(ret !== 0 ? msg : '验证失败，请核实后再提交');
      } catch (error) {
        this.disabled = false;
        Toast(error.message || '服务异常，请稍后再试');
      }
    },
    /**
     * 关闭当前页
     */
    closeWindow() {
      if (this.isH5) {
        this.$router.back();
      } else { 
        // 微信、企业微信
        WeixinJSBridge.call('closeWindow');
      }
    },
  }
}


// WEBPACK FOOTER //
// ./src/pages/verify/_verify.js